import axios from "axios";
import parse from "html-react-parser";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { MdOutlineHistory } from "react-icons/md";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaRegFileAlt } from "react-icons/fa";
import { IoSearchCircle } from "react-icons/io5";

import { IoIosArrowForward } from "react-icons/io";

import Viewer from "../../Img/user_8777874.png";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../Spinner";

import ViewSDKClient from "../ViewSDKClient";
import { API_BASE_URL } from "../../utils/config";
import { useLocation } from "react-router-dom";
import GlobalContext from "../../context/GlobalContext";
import searchIcon from "../../assets/search_10453211.png";
import InnerHamburgerNavigation from "../InnerHamburgerNavigation";
import HamburgerNavigation from "../HamburgerNavigation";
import { filterDataByUserTags } from "../../utils/commons";
import ManageCategoryImage from "../../Img/Manage categories.png";
import UpdateImage from "../../Img/update.png";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import ArticleLike from "./ArticleLike";
import NotificationImg from "../../Img/notification.png";
import AiChat from "../../Img/AI-chat.png";
import DasboardImg from "../../Img/dasboard.png";
import Select from "react-select";
import NewTopNavBar from "../NewTopNavBar";
const SingleArticle = () => {
  const [parentCategoryName, setParentCategoryName] = useState({
    id: 0,
    name: "",
  });
  const [subcategoryName, setSubCategoryName] = useState({ id: 0, name: "" });
  const [aricleData, setArticleData] = useState();
  const [catagory, setCatagory] = useState({ id: 0, name: "" });
  const [subCatagory, setSubCatagory] = useState({ id: 0, name: "" });
  const [allCatagory, setALLCategories] = useState([]);
  const [users, setUsers] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [catAndSubCat, setCatAndSubCat] = useState([]);
  const [bottomSearch, setBottomSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchSuggetions, setSearchSuggetions] = useState([]);
  const [loading, setLoding] = useState(false);
  const [loading1, setLoding1] = useState(false);
  const [pdfdep, setpdfdep] = useState(true);
  const [defaultUsersList, setDefaultUsersList] = useState([]);
  const [usersDropDownKey, setUsersDropDownKey] = useState(0);
  const [selectedUserOption, setSelectedUserOption] = useState([]);
  // const [logoutModal, setLogoutModal] = useState(false)
  // const [loadCatJson, setLoadCatJson] = useState(false)
  const [createCategoryShow, setCreateCategoryShow] = useState(false);
  const [parentCategory, setParentCategory] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [editWhistlist, setEditWhiteList] = useState(false);
  let loadCatJson = false;
  const postId = localStorage.getItem("postId");
  let bearerToken = localStorage.getItem("jwt_token");
  const viewSDKClient = new ViewSDKClient(); // Adobe View SDK client instance

  const [sanitizedContent, setSanitizedContent] = useState(undefined);

  const {
    setSettingsDropdown,
    settingsDropdown,
    logoutModal,
    setLogoutModal,
    notificationCount,
    setNotificationCount,
  } = useContext(GlobalContext);

  // Method to load PDF from URL
  const loadPDFFromURL = (divId, pdfUrl, viewerConfig) => {
    viewSDKClient.ready().then(() => {
      viewSDKClient.previewFile(divId, viewerConfig, pdfUrl);
    });
  };

  const handleInputChange = (e) => {
    const inputQuery = e.target.value;

    setSearchQuery(inputQuery);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchQuery.trim() !== "") {
        fetchPostTitles();
      } else {
        // setPostTitles([]);
        setSearchSuggetions([]);
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);

  //
  console.log("hi wgc");
  //
  const fetchPostTitles = () => {
    // console.log('searchQuery :', searchQuery != '')
    if (searchQuery != "") {
      setLoding(true);
      fetch(
        `${API_BASE_URL}/wp-json/wp/v2/posts?search=${searchQuery}&per_page=100`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // Assuming the response contains post titles as an array
          console.log("data", data);
          data = filterDataByUserTags(data);
          setSearchSuggetions(data);
          setLoding(false);
        })
        .catch((error) => {
          setLoding(false);
          // console.error(error);
        });
    } else {
      // Clear post titles if the query is empty
      setSearchSuggetions((searchSuggetions.length = 0));
      setSearchQuery("");
      setLoding(false);
    }
  };
  useEffect(() => {
    const logPostView = async () => {
      const response = await fetch(
        `${API_BASE_URL}/wp-json/custom/v1/store_author_user_id`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            post_id: postId,
            author_id: localStorage.getItem("current_user_Id"),
          }),
        }
      );

      if (!response.ok) {
        console.error("Failed to log post view:", response.statusText);
      } else {
        console.log("Post view logged successfully");
      }
    };

    logPostView();
  }, [postId]);

  const getArticle = (post) => {
    localStorage.setItem("postId", post.id);
    setLoding1(true);
    // setLoding1(loading ? false : true)
    // const query = useQuery();
    // const id = query.get('id');
    axios
      .get(`${API_BASE_URL}/wp-json/wp/v2/posts/${post.id}`, {
        // axios.get(`http://localhost:8000/postData/${post.id}`, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
        // mode: 'cors',
      })
      .then((Response) => {
        setLoding1(false);
        // console.log(Response.data);
        let articleData = document.createElement("div");
        articleData.innerHTML = Response.data.content;
        const pdfElements = articleData.querySelectorAll(".pdf-view");
        console.log("pdfElements :", pdfElements);
        pdfElements.forEach((element, index) => {
          const div = document.createElement("div");
          const div1 = document.createElement("div");
          div1.setAttribute("class", "adobe-pdf-view");
          div1.innerText = element.href;
          div1.id = `pdf-view-${index + 1}`;
          div.style.cssText = `height:500px; overflow: scroll;`;
          div.setAttribute("class", "AdobePDFView");
          div.appendChild(div1);
          element.parentNode.replaceChild(div, element);
        });
        setSanitizedContent(articleData.innerHTML);

        console.log("aricleData.innerHTML225=", articleData.innerHTML);

        setArticleData(Response.data);
      })
      .catch((err) => {
        setLoding1(false);
        // console.log(err)
      });

    let postData = {
      id: post.id,
      title: post.title.rendered.slice(0, 30),
      content: post.content.rendered.slice(0, 100),
    };
    if (localStorage.getItem("searchedData") === null) {
      let data = [];
      data.unshift();
      data.push(postData);
      localStorage.setItem("searchedData", JSON.stringify(data));
    } else {
      let oldData = JSON.parse(localStorage.getItem("searchedData"));
      console.log("oldData :", oldData);
      if (oldData.length >= 5) {
        oldData.pop();
        oldData.unshift(postData);
        localStorage.setItem("searchedData", JSON.stringify(oldData));
      } else {
        oldData.unshift(postData);
        localStorage.setItem("searchedData", JSON.stringify(oldData));
      }
    }
  };
  const pdfFrame = document.querySelectorAll(".frame");
  console.log("pdfFrame:", pdfFrame);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();
  const id = query.get("id");

  useEffect(() => {
    if (!bearerToken) {
      navigate("/");
    } else {
      setArticleData(null);

      axios
        .get(`${API_BASE_URL}/wp-json/wp/v2/posts/${id}`, {
          // axios.get(`http://localhost:8000/postData/${postId}`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((Response) => {
          console.log(Response.data);
          let articleData = document.createElement("div");
          console.log("Response.data.content", Response.data.content.rendered);
          articleData.innerHTML = Response.data.content.rendered;
          const pdfElements = articleData.querySelectorAll(".pdf-view");
          console.log("pdfElements :", pdfElements);
          pdfElements.forEach((element, index) => {
            const div = document.createElement("div");
            const div1 = document.createElement("div");
            div1.setAttribute("class", "adobe-pdf-view");
            div1.innerText = element.href;
            div1.id = `pdf-view-${index + 1}`;
            div.style.cssText = `height:500px; overflow: scroll;`;
            div.setAttribute("class", "AdobePDFView");
            div.appendChild(div1);
            element.parentNode.replaceChild(div, element);
          });
          console.log("sanitizedContent", articleData.innerHTML.toString());
          // console.log("aricleData.innerHTML225=", aricleData.innerHTML)
          setSanitizedContent(articleData.innerHTML);
          // setArticleData(Response.data)
          setArticleData(Response.data);
        });

      //

      const fetchCategories = async () => {
        // setLoading(true);
        try {
          const response = await axios.get(
            `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`,
            {
              headers: {
                Authorization: `Bearer ${bearerToken}`,
                "Content-Type": "application/json",
              },
            }
          );

          const categoryData = response.data.map((category) => ({
            id: category.id,
            name: category.name,
            parent: category.parent,
          }));

          console.log("catData=", categoryData);
          setALLCategories(categoryData);
        } catch (error) {
          console.error("Error fetching categories:", error);
        } finally {
          // setLoading(false);
        }
      };
      // if()
      fetchCategories();

      //
      fetch(`${API_BASE_URL}/wp-json/custom-user-api/v1/users`, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((users) => {
          console.log("users=", users);
          setAllUsers(users);
          // Do something with the list of users
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }, [postId]);
  // console.log("articleData1=", aricleData)

  console.log("87 allCatagory=", allCatagory);
  // console.log("articleData 88=", aricleData);
  const CatagoryData = allCatagory.filter((data, index) => {
    loadCatJson = true;

    console.log("line390=", data);
    // if (loadCatJson == true) {
    //   loadCatJson = false
    // } else {
    //   loadCatJson = true
    // }
    // if (aricleData?.categories[index] == data.id) {
    //   // setCatagory(data[0].name)
    //   return data.name
    // }
    // console.log("390=", aricleData)
    for (let i = 0; i < allCatagory.length; i++) {
      for (let j = 0; j < aricleData?.categories.length; j++) {
        // console.log(data)
        if (aricleData.categories[j] == data.id && data.parent == 0) {
          parentCategoryName.id = data.id;
          parentCategoryName.name = data.name;
          // setParentCategoryName({ id: data.id, name: data.name })
          // ghj
          // return data.name
        } else if (aricleData.categories[j] == data.id) {
          subcategoryName.id = data.id;
          subcategoryName.name = data.name;
          // setSubCategoryName({ id: data.id, name: data.name })
        }
      }
    }
  });
  console.log("CATdATA101=", CatagoryData);

  useEffect(() => {
    if (!bearerToken) {
      navigate("/");
    } else {
      axios
        .get(`${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          console.log("104REs=", res.data);
          console.log("CATdATA106=", CatagoryData);
          for (let i = 0; i < res.data.length; i++) {
            for (let j = 0; j < CatagoryData.length; j++) {
              // console.log("108 Line", res.data[i])
              // console.log(`110Data ${res.data[i].parent} ${res.data[i].parent == 0} catagory ${CatagoryData[j].id == (res.data[i].id)}`);
              if (
                res.data[i].parent == 0 &&
                CatagoryData[j].id == res.data[i].id
              ) {
                // alert(res.data[i].name)
                // setCatagory()
                setCatagory({ id: res.data[i].id, name: res.data[i].name });
                // catagory.id = res.data[i].id;
                // catagory.name = res.data[i].name;
              }
              if (
                res.data[i].parent != 0 &&
                CatagoryData[j].id == res.data[i].id
              ) {
                // setCatagory()
                // alert(res.data[i].name)
                setSubCatagory({ id: res.data[i].id, name: res.data[i].name });

                // subCatagory.id = res.data[i].id;
                // subCatagory.name = res.data[i].name;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
      console.log(`Catagory 131=${catagory.name} subCata= ${subCatagory.name}`);
    }
    //

    //
  }, [loadCatJson, loading1]);

  console.log(`Catagory=${catagory.name} subCata= ${subCatagory.name}`);

  // alert(catagory)
  // console.log("articleData=", aricleData)
  const allUsersData = allUsers.filter((data) => {
    // console.log(aricleData.author)
    // console.log("id=", data.ID);
    if (aricleData?.author == data.ID) {
      return data.user_login;
    }
  });
  console.log("allusers=", allUsersData);
  console.log("postId=", postId);
  const storedEmail = localStorage.getItem("userEmail");
  const navigate = useNavigate();
  const backBtn = () => {
    navigate("/table-posts");
  };
  const uploadUsers = () => {
    navigate("/create-new-user-form");
  };
  const logOutBtn = async () => {
    await localStorage.removeItem("jwt_token");
    await localStorage.removeItem("tags");
    navigate("/");
    await window.location.reload();
  };
  const myArticlesPage = () => {
    navigate("/table-posts");
  };
  const HomeBtn = () => {
    localStorage.removeItem("catagoryId");
    navigate("/default-page");
  };
  const catagoryHandle = (catId) => {
    localStorage.setItem("catagoryId", catId);
    navigate("/subcategory");
  };
  const subCatagoryHandle = (subCatId, catId, name) => {
    navigate("/category-posts");
    localStorage.setItem("catagoryId", catId);
    localStorage.setItem("subcategoryName", name);
    localStorage.setItem("subcategoryId", subCatId);
  };
  const rolles = localStorage.getItem("roles");

  //

  // if(document.body.scroll > 20){
  //   document.getElementById('bottomSearch').style.bottom = '30px'
  // }

  const preparePdfView = () => {
    let div = document.createElement("div");
    div.innerHTML = sanitizedContent;
    let pdfElements = div.querySelectorAll(".adobe-pdf-view");
    console.log("adobe_dc_view_sdk called");
    console.log("pdfElements 53:", pdfElements);
    pdfElements.forEach((element, index) => {
      const previewConfig = {
        defaultViewMode: "FIT_WIDTH",
        //    defaultViewMode: 'SINGLE_PAGE',
        showAnnotationTools: false,
        showLeftHandPanel: false,
        showPageControls: false,
        showDownloadPDF: false,
        showPrintPDF: false,
        // showZoomControl: false,
        showThumbnails: false,
        showFullScreen: true,
      };

      const pathAfterUploads = element.innerText.split("/uploads/")[1];
      // http://localhost:8080/
      // const newURL = `https://kr.camptratech.com/kr/wp-content/uploads/${pathAfterUploads}`;
      const newURL = `${API_BASE_URL}/wp-content/uploads/${pathAfterUploads}`;
      loadPDFFromURL(element.id, newURL, previewConfig);
    });
  };

  useEffect(() => {
    sanitizedContent && preparePdfView();
  }, [aricleData]);

  function changeDateFormat(originalDate) {
    // Parse the original date string
    const parsedDate = new Date(originalDate);

    // Extract the day, month, and year components
    const day = parsedDate.getDate().toString().padStart(2, "0");
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const year = parsedDate.getFullYear();

    // Construct the new date format
    const newDateFormat = `${month}-${day}-${year}`;

    return newDateFormat;
  }
  console.log("550=", aricleData);
  // const formattedDate = "dsf"
  const originalDate = aricleData?.modified?.slice(0, 10);
  const formattedDate = changeDateFormat(originalDate);
  console.log("429=", formattedDate);

  //
  const extractSentences = (text, query) => {
    // Remove certain HTML tags (e.g., img) from the text
    const sanitizedText = text.replace(
      /<\/?(img|iframe|yourtagnamehere)[^>]*>/g,
      ""
    );

    const sentences = sanitizedText.split(/[\.\?\!]/g);
    const filteredSentences = sentences.filter((sentence) =>
      sentence.toLowerCase().includes(query.toLowerCase())
    );
    return filteredSentences.slice(0, 1); // Show the first two sentences
  };

  const highlightQuery = (text, query) => {
    const regex = new RegExp(query, "gi");
    return text.replace(
      regex,
      (match) => `<span style="background-color: yellow;">${match}</span>`
    );
  };
  const WigetTable = () => {
    navigate("/wiget-admin");
  };
  const manageLog = () => {
    navigate("/logo");
  };
  const NewCampraLogo = localStorage.getItem("logoImg");
  //

  // recomandation start
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const getParentCategories = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom-user-api/v1/users`, config)
      .then((res) => {
        console.log("getAllCategories=", res.data);

        // const filterData = res.data.filter((data) => data.parent == 0);
        // console.log("filterData=", filterData)
        setParentCategory(res.data);
        // setSelectedIds(filterData.map(item => item.id))
      })
      .catch((err) => {
        console.log(err);
      });
  };
  console.log("line11=", selectedIds);

  const handleCategoryClose = () => {
    setCreateCategoryShow(false);
    setSelectedIds(parentCategory.map((item) => item.id));
  };
  const handleShowCategory = () => {
    setCreateCategoryShow(true);
  };

  const handleCheckboxChange = (id) => {
    if (selectedIds?.includes(id)) {
      setSelectedIds(selectedIds.filter((itemId) => itemId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };
  const handleCreateCategory = () => {
    console.log("line549=", selectedUserOption);
    let author = [];
    for (let i = 0; i < selectedUserOption.length; i++) {
      author.push(selectedUserOption[i].user_login);
    }
    let author_name = author.join(",");
    //
    let notification_api_data = {
      author: localStorage.getItem("display_name"),
      articles: aricleData.title.rendered,
      event_type: "recommendation",
      name: author_name,
      article_ids: postId,
    };

    axios
      .post(
        `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
        notification_api_data,
        config
      )
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    //

    // e.preventDefault();
    if (selectedUserOption.length < 1) {
      toast.error("Please select at least one category.");
      return;
    } else {
      let userIds = [];
      for (let i = 0; i < selectedUserOption.length; i++) {
        userIds.push(selectedUserOption[i].ID);
      }
      console.log("line556=", userIds);
      const data = {
        ids: userIds,
        postId: aricleData.id,
        postTitle: aricleData.title.rendered,
      };
      axios
        .post(
          `${API_BASE_URL}/wp-json/custom/v1/recomandation-ids/`,
          data,
          config
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });

      setCreateCategoryShow(false);
    }
  };
  const chatModalOpen = () => {
    navigate("/analytics-dashboard");
  };
  // get recomanded id's start

  const getRecomandedIds = () => {
    axios
      .get(
        `${API_BASE_URL}/wp-json/custom/v1/get-recommended-data/${aricleData.id}`,
        config
      )
      .then((res) => {
        console.log(res);
      });
  };

  // get recomanded id's end
  useEffect(() => {
    getParentCategories();
    axios
      .get(
        `${API_BASE_URL}/wp-json/custom/v1/get-count/?user_id=${localStorage.getItem(
          "current_user_Id"
        )}`,
        config
      )
      .then((res) => {
        console.log(res);
        setNotificationCount(res.data.count_value);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const notifications = () => {
    let notification_count = {
      user_id: localStorage.getItem("current_user_Id"),
      count_value: 0,
      reflect_count: "set_count",
    };
    // if (notification_count.user_id != "") {
    // post notification on usermeta start
    axios
      .post(
        `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
        notification_count,
        config
      )
      .then((res) => {
        console.log(res.data);
        setNotificationCount(0);
      })
      .catch((err) => {
        console.log(err);
      });
    // }
    navigate("/notification");
  };

  // recomandation end
  return (
    <div onClick={() => setBottomSearch(false)} style={{ minHeight: "95vh" }}>
      {/*  */}
      <InnerHamburgerNavigation />
      <HamburgerNavigation />
      <div>
        <NewTopNavBar />
      </div>
      {/* <div className='w-100 top-nav'>
        <div className="header justify-content-between " style={{ padding: "0 20px" }}>
          <div className='ps-5'>
            <img style={{ width: "100%", height: '65px' }} src={NewCampraLogo} alt="" />
          </div>
          <div>
            <div style={{ cursor: "pointer" }} className='ps-4' onClick={HomeBtn}>
          
            </div>
            {rolles == "administrator" ? <div className='d-flex'>
              <div onClick={() => { navigate('/default-page') }} role='button' className='manage-users  p-2 rounded '  >

                Home

              </div>

              <div className="back-screen ">

                <button onClick={HomeBtn}>
            
                  <img data-bs-toggle="tooltip" data-bs-placement="top" title="Advance Chat" width={40} src={AiChat} alt="" />
                </button>
              </div>
              <div className="back-screen d-flex flex-column position-relative" style={{ backgroundColor: 'whitesmoke' }}>
                <button className='setting-btn' onClick={(e) => { e.stopPropagation(); settingsDropdown ? setSettingsDropdown(false) : setSettingsDropdown(true) }} >
                  Settings {settingsDropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </button>
                {settingsDropdown &&

                  (
                    <div className='d-flex flex-column position-absolute rounded align-items-start' style={{ top: '40px', backgroundColor: 'whitesmoke', width: 'max-content' }}>
                      <div onClick={() => navigate("/create-new-user-form")} role='button' className='manage-users p-2 rounded '  >
                        Manage users
                      </div>
                      <div onClick={() => navigate("/create-subctegory")} role='button' className='manage-users  p-2 rounded '  >
                        Manage Categories
                      </div>
                      <div onClick={() => navigate("/create-tag")} role='button' className='manage-users  p-2 rounded '  >
                        Manage Tags
                      </div>
                      <div onClick={WigetTable} role='button' className='manage-users  p-2 rounded '  >

                        Manage Widget

                      </div>
                      <div onClick={manageLog} role='button' className='manage-users  p-2 rounded '  >

                        Manage Logo

                      </div>
                    </div>
                  )

                }
              </div>

              <div className="back-screen">
                <button
                  onClick={backBtn}>
                  
                  My Articles
                </button>
              </div>
              <div className="back-screen ">

                <button
                
                  onClick={chatModalOpen}
                >
                  <img data-bs-toggle="tooltip" data-bs-placement="top" title="Dasboard" width={35} src={DasboardImg} alt="" />

                </button>
              </div>
           

              <div className="user-det new-user-det-single-article position-relative">
                <div className="usr-bac">
                  <img
                    src={Viewer}
                    style={{ width: "35px" }}
                    alt=""
                  />
                  <div className="user-name d-flex">
                    <div>
                      <p id="usrname">{localStorage.getItem("display_name")}</p>
                      <p id="usrrole">Admin</p>
                    </div>
                    <div>
                      {logoutModal ? <IoIosArrowUp role='button' onClick={() => setLogoutModal(false)} /> : <IoIosArrowDown role='button' onClick={(e) => { e.stopPropagation(); setLogoutModal(true) }} />}
                    </div>
                  </div>

                </div>
                {logoutModal && <div className='p-2 position-absolute rounded text-center' style={{ border: '1px solid', left: '60px', width: "60%", background: 'white', cursor: 'pointer' }}>
                  <span className='text-danger' onClick={logOutBtn} role='button'>Logout</span>
                </div>}
              </div>
            </div> :
              rolles == 'author' ?

                <div className='d-flex'>
                 
                  <div onClick={() => { navigate('/default-page') }} role='button' className='manage-users  p-2 rounded '  >

                    Home

                  </div>
                  <div className="back-screen ">
                    <button onClick={HomeBtn}>
                     
                      <img data-bs-toggle="tooltip" data-bs-placement="top" title="Advance Chat" width={40} src={AiChat} alt="" />
                    </button>
                  </div>
                  <div className="back-screen d-flex flex-column position-relative" style={{ backgroundColor: 'whitesmoke' }}>
                    <button className='setting-btn' onClick={(e) => { e.stopPropagation(); settingsDropdown ? setSettingsDropdown(false) : setSettingsDropdown(true) }} >
                      Settings {settingsDropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
                    </button>
                    {settingsDropdown &&

                      (
                        <div className='d-flex flex-column position-absolute rounded' style={{ top: '40px', backgroundColor: 'whitesmoke', width: 'max-content' }}>
                        
                          <div onClick={() => navigate("/create-subctegory")} role='button' className='manage-users  p-2 rounded '  >
                            Manage Categories
                          </div>
                        </div>
                      )

                    }
                  </div>
                  <div className="back-screen ">
                    <button


                      onClick={backBtn}>
                    
                      My Articles
                    </button>

                  </div>
                
                  <div className="user-det new-user-det-single-article position-relative">
                    <div className="usr-bac">
                      <img
                        src={Viewer}
                        style={{ width: "35px" }}
                        alt=""
                      />
                      <div className="user-name d-flex">
                        <div>
                          <p id="usrname">{localStorage.getItem("display_name")}</p>
                          <p id="usrrole">Author</p>
                        </div>
                        
                      </div>

                    </div>
                   
                  </div>

                </div>
                :
                rolles == "editor" ? <div className='d-flex'>




                  <div className="back-screen ">
                    <button onClick={HomeBtn}>
                     
                      <img data-bs-toggle="tooltip" data-bs-placement="top" title="Advance Chat" width={40} src={AiChat} alt="" />
                    </button>
                  </div>




                  <div className="back-screen ">

                    <button
                   
                      onClick={chatModalOpen}
                    >
                      <img data-bs-toggle="tooltip" data-bs-placement="top" title="Dasboard" width={35} src={DasboardImg} alt="" />
                    </button>
                  </div>

               

                  <div className="user-det position-relative">
                    <div className="usr-bac">
                      <img
                        src={Viewer}
                        style={{ width: "35px" }}
                        alt=""
                      />
                      <div className="user-name d-flex">
                        <div>
                          <p id="usrname">{localStorage.getItem("display_name")}</p>
                          <p id="usrrole">Tenant  Admin</p>
                        </div>
                        <div>
                          {logoutModal ? <IoIosArrowUp role='button' onClick={() => setLogoutModal(false)} /> : <IoIosArrowDown role='button' onClick={(e) => { e.stopPropagation(); setLogoutModal(true) }} />}
                        </div>
                      </div>

                    </div>
                    {logoutModal && <div className='p-2 position-absolute rounded text-center' style={{ zIndex: '1', border: '1px solid', left: '60px', width: "60%", background: 'white', cursor: 'pointer' }}>
                      <span className='text-danger' onClick={logOutBtn} role='button'>Logout</span>
                    </div>}
                  </div>
                </div>
                  : <div className='d-flex'>
                    <div onClick={() => { navigate('/default-page') }} role='button' className='manage-users  p-2 rounded '  >

                      Home

                    </div>
                    <div className="back-screen ">
                      <button onClick={HomeBtn}>
                      
                        <img data-bs-toggle="tooltip" data-bs-placement="top" title="Advance Chat" width={40} src={AiChat} alt="" />
                      </button>
                    </div>
                 
                    <div className="user-det new-user-det-single-article position-relative">
                      <div className="usr-bac">
                        <img
                          src={Viewer}
                          style={{ width: "35px" }}
                          alt=""
                        />
                        <div className="user-name d-flex">
                          <div>
                            <p id="usrname">{localStorage.getItem("display_name")}</p>
                            <p id="usrrole">Reader</p>
                          </div>
                          <div>
                            {logoutModal ? <IoIosArrowUp role='button' onClick={() => setLogoutModal(false)} /> : <IoIosArrowDown role='button' onClick={(e) => { e.stopPropagation(); setLogoutModal(true) }} />}
                          </div>
                        </div>
                        <div className="back-screen notificaion-screen">
                          <button onClick={notifications} className="notification-button">
                            <img src={NotificationImg} data-bs-toggle="tooltip" data-bs-placement="top" title="Notification" alt="" className="notification-icon" />
                            {notificationCount > 0 && <div className="notification-count">{notificationCount}</div>}
                          </button>
                        </div>
                      </div>
                      {logoutModal && <div className='p-2 position-absolute rounded text-center' style={{ border: '1px solid', left: '60px', width: "60%", background: 'white', cursor: 'pointer' }}>
                        <span className='text-danger' onClick={logOutBtn} role='button'>Logout</span>
                      </div>}
                    </div>
                  </div>
            }
          </div>
        </div>
      </div>  */}

      {/*  */}
      {/* recomandation modal start*/}
      {/* add/edit categorymodal */}
      <Modal show={createCategoryShow} onHide={handleCategoryClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {/* {editWhistlist ? "Update" : "Add"} */}
            Send Recomandation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row g-0 w-100 ">
            <div className="p-1 pe-2">
              <Select
                key={usersDropDownKey}
                closeMenuOnSelect={false}
                className="tagSelectorMulti"
                isMulti={true}
                placeholder="Select Tags"
                getOptionLabel={(option) => option.user_login}
                getOptionValue={(option) => option.ID}
                options={allUsers}
                onChange={setSelectedUserOption}
                // defaultValue={allUsers}
              />
            </div>

            {/* {allUsers ? allUsers.map(item => (
              <div key={item.id}>
                <input
                  type="checkbox"
                  id={item.slug}
                  value={item.id}
                  checked={selectedIds?.includes(item?.id)}
                  onChange={() => handleCheckboxChange(item.id)}
                />
                <label htmlFor={item.user_login}>{item.user_login}</label>
              </div>
            )) : ""} */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button> */}
          {/* <Button variant="primary" onClick={handleCreateCategory}>
                                {editWhistlist ? "Update" : "Add"}
                            </Button> */}
          {editWhistlist ? (
            <img
              onClick={handleCreateCategory}
              width={40}
              data-toggle="tooltip"
              data-placement="bottom"
              title="Update"
              role="button"
              src={UpdateImage}
              alt="Update"
            />
          ) : (
            <img
              onClick={handleCreateCategory}
              width={50}
              data-toggle="tooltip"
              data-placement="bottom"
              title="Add"
              role="button"
              src={UpdateImage}
              alt="Add"
            />
          )}
        </Modal.Footer>
      </Modal>

      {/* add/edit categorymodal */}
      {/* recomandation modal end */}

      <div
        // className=" search-container-main-div-new  row "
        className=" row g-0"
        style={{ height: "auto" }}
      >
        <div
          // className="column right-column "
          className="col-12"
        >
          <div>
            {/* 
     <button className="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0 "><i className="fas fa-bars" ></i></button> */}
          </div>
          {/*  */}

          {/*  */}

          {aricleData?.status == "trash" ? (
            <h4 className="text-center pt-5">This Article is deleted</h4>
          ) : (
            <div
              className="w-100 article"
              style={{ minHeight: "80vh", padding: "20px 60px" }}
            >
              {!loading1 ? (
                aricleData ? (
                  <div
                    className="article-content"
                    style={{
                      padding: "3rem",
                      minHeight: "80vh",
                      boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <div className="fw-bold py-2 bredcamp">
                      <span
                        style={{ cursor: "pointer" }}
                        className="hyperlinkCard2 bredcampColor"
                        onClick={HomeBtn}
                      >
                        Home
                      </span>
                      {/* <span>||</span> */}
                      {/* <img className='hyperlinkCard2' style={{ width: "1.2%", margin: '0px 8px' }} src={RightArrow} alt="" /> */}
                      <IoIosArrowForward />
                      {console.log("829=", catagory.name)}
                      <span
                        onClick={() => catagoryHandle(parentCategoryName.id)}
                        style={{ cursor: "pointer" }}
                        className="hyperlinkCard2 bredcampColor"
                      >
                        {parentCategoryName.name}
                      </span>
                      {subcategoryName.name != "" ? (
                        <span>
                          {/* <img className='hyperlinkCard2' style={{ width: "1.2%", margin: '0px 8px' }} src={RightArrow} alt="" /> */}
                          <IoIosArrowForward />
                          <span
                            onClick={() =>
                              subCatagoryHandle(
                                subcategoryName.id,
                                parentCategoryName.id,
                                subcategoryName.name
                              )
                            }
                            style={{ cursor: "pointer" }}
                            className="hyperlinkCard2 bredcampColor"
                          >
                            {subcategoryName.name}
                          </span>
                        </span>
                      ) : (
                        ""
                      )}
                      {/* <span>||</span> */}
                      {/* <img style={{ width: "1.2%", margin: '0px 8px' }} src={RightArrow} alt="" />
                  <span className='hyperlinkCard2 text-info'>{aricleData.title.rendered}</span> */}
                    </div>
                    <h2 className="article-title">
                      {aricleData.title.rendered}
                    </h2>
                    <ArticleLike
                      postId={postId}
                      article_name={aricleData.title.rendered}
                      author_id={aricleData.author}
                    />
                    {/* <div className=''>
                  <img src={ManageCategoryImage} alt="" onClick={handleShowCategory} />
                </div> */}
                    <div className="d-flex pb-3 article-info">
                      <p className=" m-0 fw-bolder article-lastUpdate">
                        Last Updated: {formattedDate}{" "}
                      </p>
                      <span className="px-2">|</span>
                      <p className="m-0 fw-bolder article-author">
                        Author:{" "}
                        {allUsersData ? allUsersData[0]?.user_login : ""}
                      </p>
                      <span className="px-2">|</span>
                      <p className="m-0  fw-bolder article-category">
                        {parentCategoryName.name}
                      </p>
                    </div>
                    {/*  */}

                    <div
                      className="articleView"
                      dangerouslySetInnerHTML={{
                        __html: sanitizedContent,
                      }}
                    ></div>
                    {/*  */}
                    {/* {aricleData.content.rendered.includes(".pdf") &&
                (() => {
                  const pdfUrlsMatch =
                    aricleData.content.rendered.match(/http.*?\.pdf/g);
                  if (pdfUrlsMatch && pdfUrlsMatch.length > 0) {
                    return pdfUrlsMatch.map((pdfUrl, index) => (
                      <div
                        id={`pdf-div-${index + 1}`}
                        style={{ width: "50%", height: "500px" }}
                      >
                        {loadPDF(aricleData.content.rendered)}
                      </div>
                    ));
                  } else {
                    return null;
                  }
                })()} */}
                  </div>
                ) : (
                  <div className="text-center w-100 my-5">
                    <Spinner />
                  </div>
                )
              ) : (
                <div className="text-center w-100 my-5">
                  <Spinner />
                </div>
              )}
              {/*  */}
            </div>
          )}
        </div>
        <div
          id="bottomSearch"
          className=" d-flex justify-content-end fixed-bottom z-1"
          style={{
            height: `${bottomSearch ? "540px" : ""}`,
            bottom: "50px",
            transition: "ease",
            width: "fit-content",
            left: "auto",
          }}
        >
          {
            // !bottomSearch ? <button className='btn btn-primary rounded-pill' onClick={() => setBottomSearch(true)}>Search</button>
            // !bottomSearch ? <img role='button' src={searchIcon} width={45} height={45} onClick={() => setBottomSearch(true)}/>
            !bottomSearch ? (
              <IoSearchCircle
                className="bottom-search-icon"
                role="button"
                color="#007BFF"
                size={55}
                onClick={(e) => {
                  e.stopPropagation();
                  setBottomSearch(true);
                }}
              />
            ) : (
              <div
                onClick={(e) => e.stopPropagation()}
                className="search-popup d-flex flex-column shadow bg-light rounded "
                style={{ height: "100%", width: "360px", paddingRight: "10px" }}
              >
                <div
                  className="bg-primary py-3 search-popup-header "
                  style={{ width: "360px", borderRadius: "6px 6px 0 0" }}
                >
                  <div className=" d-flex justify-content-between mx-2">
                    <span className="text-light">Search</span>
                    <IoIosArrowDown
                      size={20}
                      role="button"
                      onClick={() => {
                        setBottomSearch(false);
                        setSearchSuggetions([]);
                        setSearchQuery("");
                      }}
                    />
                  </div>
                </div>
                <div className=" w-100" style={{ height: "350px" }}>
                  <div className="d-flex p-3">
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Search"
                      value={searchQuery}
                      onChange={handleInputChange}
                      // onChange={(e) => { fetchPostTitles(e.target.value); setSearchQuery(e.target.value) }}
                    />
                  </div>
                  <div
                    className="search-popup-results d-flex flex-column align-items-start"
                    style={{ overflow: "scroll", height: "400px" }}
                  >
                    {console.log(
                      "searchSuggetions.length:",
                      searchSuggetions.length
                    )}
                    {!loading ? (
                      searchQuery != "" && searchSuggetions.length > 0 ? (
                        searchSuggetions.map((element, index) => {
                          return (
                            <div
                              key={index}
                              className="rounded p-2 mx-4 my-2 d-flex search-result"
                              style={{
                                backgroundColor: "#0000000a",
                                width: "-webkit-fill-available",
                              }}
                              onClick={() => {
                                getArticle(element);
                                setBottomSearch(false);
                                setSearchSuggetions([]);
                                setSearchQuery("");
                              }}
                            >
                              <div className="h-100">
                                <FaRegFileAlt size={21} />
                              </div>
                              <div className="d-flex flex-column align-items-start ps-2 pt-1">
                                {/* <h6 className='search-result-text'>{element.title.rendered.slice(0, 30)}...</h6> */}
                                {/* <span className='text-wrap ' style={{ fontSize: '13px' }}>{element.content.rendered && parse(element.content.rendered.slice(0, 70).toString())}</span> */}
                                <h6
                                  dangerouslySetInnerHTML={{
                                    __html: highlightQuery(
                                      element.title.rendered.length > 30
                                        ? `${element.title.rendered.slice(
                                            0,
                                            30
                                          )}...`
                                        : element.title.rendered,
                                      searchQuery
                                    ),
                                  }}
                                />

                                {/* {console.log("total content=", result.excerpt.rendered)} */}
                                {element.excerpt.rendered && (
                                  <div>
                                    {extractSentences(
                                      element.content.rendered,
                                      searchQuery
                                    ).map((sentence, index) => (
                                      <p
                                        key={index}
                                        dangerouslySetInnerHTML={{
                                          __html: highlightQuery(
                                            sentence,
                                            searchQuery
                                          ),
                                        }}
                                      />
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <>
                          {searchQuery == "" ? (
                            <div className="w-100 ">
                              <h6 className="mb-2 text-center">
                                Recently searched
                              </h6>
                              {JSON.parse(
                                localStorage.getItem("searchedData")
                              ) &&
                                JSON.parse(
                                  localStorage.getItem("searchedData")
                                ).map((post, index) => {
                                  return (
                                    <div
                                      key={index}
                                      className="rounded p-2 mx-4 my-2 d-flex align-items-start search-result"
                                      style={{ backgroundColor: "#0000000a" }}
                                    >
                                      <div className="h-100 ">
                                        <MdOutlineHistory size={22} />
                                      </div>
                                      <div className="d-flex flex-column align-items-start ps-2 pt-1">
                                        <h6 className="search-result-text">
                                          {post.title}...
                                        </h6>
                                        {/* <span className='text-wrap ' style={{ fontSize: '13px' }}>{post.content && parse(post.content)}</span> */}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          ) : (
                            <span className="m-auto">No results found</span>
                          )}
                          {/* <span>No results found</span> */}
                        </>
                      )
                    ) : (
                      <div className="d-flex justify-content-center w-100">
                        <Spinner />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </div>
    // </div>
  );
};

export default SingleArticle;
